import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Push = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2.08582L7.05025 7.03556L8.46447 8.44978L11 5.91424V16.1707C9.83481 16.5826 9 17.6938 9 19C9 20.6569 10.3431 22 12 22C13.6569 22 15 20.6569 15 19C15 17.6938 14.1652 16.5826 13 16.1707V5.91424L15.5355 8.44978L16.9497 7.03556L12 2.08582ZM12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
      fill="currentColor"
    />
  </Icon>
));

export default Push;
